import React from 'react'
import { getLocaleFreePathname } from 'app/history'
import { getDomainConfig } from 'app/utils/browser'
import { findLanguage } from 'mz-intl/core/languages'
import { Route, Redirect, Switch } from 'react-router-dom'

const LocaleRoute = ({ children }) => (
  <Switch>
    {/* Handle routes with locale prefix. E.g.: /en-us */}
    <Route path="/:locale([a-z]{2}|[a-z]{2}-[a-z]{2})">
      {({ match, location }) => {
        const requestLocale = (match?.params.locale || '').toLowerCase().trim()
        const defaultLang = findLanguage(getDomainConfig().locale || '')
        const actualLang = findLanguage(requestLocale, defaultLang.value)

        // If requested locale doesn't match actual language, redirect to correct locale
        if (actualLang.value !== requestLocale) {
          const localeFreePath = getLocaleFreePathname(location.pathname)
          const newPathname = `/${actualLang.value}/${localeFreePath}`.replace(/\/{2,}/g, '/')

          return <Redirect to={{ ...location, pathname: newPathname }} />
        }

        return children(actualLang.value)
      }}
    </Route>

    {/* Handle routes without locale prefix. E.g.: / */}
    <Route>
      {({ location }) => {
        const domainConfig = getDomainConfig()

        // If domain has a specific locale configured, redirect to that
        if (domainConfig.locale) {
          const domainLang = findLanguage(domainConfig.locale)
          const newPathname = `/${domainLang.value}${location.pathname}`.replace(/\/{2,}/g, '/')
          return <Redirect to={{ ...location, pathname: newPathname }} />
        }

        // Otherwise, use en-us without redirect
        return children('en-us')
      }}
    </Route>
  </Switch>
)

export default LocaleRoute
